// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/** Text color for old (removed/overwritten) values — red strikethrough. */
/** Text color for new (added/replacement) values — green. */
/** Row background for wholly new rows (component or valve added in this revision). */
/** Row background for wholly deleted rows (present in previous revision, absent in current). */
/** Text color for deleted row cells (dark red, pairs with \$compare-row-deleted-bg). */
/** Text color for new row cells (dark green, pairs with \$compare-row-new-bg). */
.retire-pipe-class {
  display: flex;
  align-items: center;
  font-family: "GothamBold", Arial, sans-serif;
  font-weight: bold;
  font-size: 14px;
  letter-spacing: 0px;
  color: #97002e;
  white-space: nowrap;
}
.retire-pipe-class :hover {
  cursor: pointer;
  color: rgb(100, 0, 30.4635761589);
}

.retire-icon {
  font-size: 18px;
  vertical-align: middle;
  margin-left: 4px;
}

.text-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  margin: 0;
  padding: 0;
  color: #97002e;
  font-family: "GothamBold", Arial, sans-serif;
  font-size: 14px;
  cursor: pointer;
}
.text-button:hover {
  color: rgb(100, 0, 30.4635761589);
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
